import React from 'react'

import * as styles from './sidebar.module.scss'

export const SidebarItem: React.FC<{
  text: string
  link: string
  icon: React.FC
}> = ({ text, link, icon: Icon }) => (
  <a className={styles.sidebar__link} href={link}>
    <Icon />
    <span className={styles.sidebar__text}>{text}</span>
  </a>
)
